import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  mainWrap: {
    position: 'relative',
  },
  wrap: {
    marginBottom: '24px',
    display: 'flex',
    gap: '24px',
    width: '100%',
    overflow: 'hidden',
    height: '464px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      height: 'fit-content',
    },
  },
  leftWrap: (isVertical: boolean, isPlaceholder: boolean, isLegend: boolean) => ({
    position: 'relative',
    maxWidth: isPlaceholder ? '464px' : '65%',
    overflow: 'hidden',
    borderRadius: '25px',

    ...(isLegend && {
      borderBottomRightRadius: 0,
    }),

    '@media (min-width: 1680px)': {
      ...((isVertical || isPlaceholder) && {
        width: '40%',
        maxWidth: '40%',
        borderBottomRightRadius: '25px',
      }),
    },

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      width: '100%',
      maxWidth: '100%',
      height: 'fit-content',
    },
  }),
  inner: (isBlur: boolean) => ({
    overflow: 'hidden',
    width: '100%',
    height: '100%',

    '@media (min-width: 1680px)': {
      ...(isBlur && {
        background: 'rgba(69, 69, 69, 0.1)',
        backdropFilter: 'blur(12px)',
      }),
    },

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      height: 'fit-content',
    },
  }),
  bgImage: {
    display: 'none',
    position: 'absolute',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',

    '@media (min-width: 1680px)': {
      display: 'block',
    },
  },
  outOfStock: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    background: customTheme.custom.gray.G100,
    opacity: 0.5,
  },
  outOfStockTag: {
    display: 'inline-flex',
    padding: '4px 8px',
    justifyContent: 'flex-start',
    alignItems: 'center',

    position: 'absolute',
    fontWeight: 600,
    color: customTheme.custom.black,
    right: '0px',
    top: '27px',
    width: '100px',
    fontSize: '14px',

    borderRadius: '8px 0px 0px 8px',
    background: customTheme.custom.gray.G100,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.2)',
  },
  image: (isVertical: boolean) => ({
    width: '100%',
    height: '464px',
    objectFit: 'cover',
    objectPosition: 'center',

    '@media (min-width: 1680px)': {
      ...(isVertical && {
        objectFit: 'contain',
      }),
    },

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      display: 'block',
      width: '100%',
      maxWidth: '100%',
      objectFit: 'contain',
      height: 'auto',
    },
  }),
  cardWrap: {
    width: '35%',
    flexGrow: '1',
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    borderRadius: '25px',

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      display: 'none',
    },
  },
  minOrder: {
    position: 'absolute',
    right: '12px',
    bottom: '-16px',
    fontWeight: 500,
    fontSize: '10px',
    lineHeight: '10px',
    color: customTheme.custom.black.B100,
  },
};
